<template>
  <v-data-table
    :headers="headers"
    :items="estudios"
    class="transparent"
    :loading="loading"
    :options="{ page: false }"
    :hide-default-footer="true"
    calculate-widths
  >
    <template v-slot:[`item.opciones`]="{ item }">
      <span class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton class="mr-2" icon="mdi-pencil" variant="primary" @click="$emit('edit', item)" />
            </span>
          </template>
          <span>Editar Estudio</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>

<script>
import IconButton from '../../base/IconButton.vue'

export default {
  components: {
    IconButton,
  },
  props: {
    estudios: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Institución', value: 'institucion' },
        { text: 'Generación', value: 'generacion' },
        { text: 'Estatus', value: 'CatEstatusEstudio.title' },
        { text: 'Comprobante', value: 'ComprobanteEstudio.title' },
        { text: 'Grado', value: 'CatEstudios.title' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Opciones', value: 'opciones', align: 'center', sortable: false },
      ],
    }
  },
}
</script>
